import React from "react";
import { AppInfo } from "../types";
import { onTap, onLongTouch as longTouchListener } from "@/utils/mobileEvent";
import { IconFont } from "@/components/IconFont";
import styles from "./styles.module.less";
import classNames from "classnames";
import { openApp } from "../openApp";

export const MobileAppItemCard = React.memo<{
  appInfo: AppInfo;
  showDeleteIcon?: boolean;
  onLongTouch?: () => void;
  onRemove?: () => void;
}>(({ appInfo, showDeleteIcon, onLongTouch, onRemove }) => {
  return (
    <div
      onTouchStart={(evt) => {
        if (showDeleteIcon) {
          return;
        }
        longTouchListener(evt.target, () => onLongTouch?.(), 1000);
        onTap(evt.target, () => openApp(appInfo));
      }}
      className={classNames(styles.mobileAppItem, {
        [styles.deleteVisible]: showDeleteIcon,
      })}
    >
      <img
        className={styles.mobileAppLogo}
        src={appInfo.logo}
        alt={appInfo.name}
        onMouseDown={(e) => {
          // iOS 中长按图片会在新窗口打开
          e.preventDefault();
        }}
      />
      <div className={styles.mobileAppName}>{appInfo.name}</div>

      <div
        onTouchStart={(evt) => {
          evt.stopPropagation();
          onTap(evt.target, () => onRemove?.());
        }}
        className={classNames(styles.mobileAppDelete)}
      >
        <IconFont type="authing-close-line" />
      </div>
    </div>
  );
});
